import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SWCTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SWCType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SWCType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SWCTYPE_CONFIG = {
  entityName: 'SWCType',
  localizationKey: 'Planning::Entity.SWCType',
  fields: SWCTYPE_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SWCTypes',
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,

};
